<template>
    <div
        class="h-lvh w-full fixed z-30 top-0 left-0 bg-gray-transparent flex items-center justify-center overflow-auto"
        :class="{
            'hidden': !isVisible,
            'block': isVisible
        }"
    >
        <div
            class="bg-white shadow-sm flex flex-col w-full h-full
                xs:w-full xs:h-full
                sm:w-full sm:h-full
                lg:max-w-[1280px] lg:w-[calc(100%-64px)] lg:h-5/6 lg:rounded-lg
            "
            :class="{
                'hidden': !isVisible,
                'block': isVisible
            }"
        >
            <div class="w-full border-b border-gray-300 justify-between items-center h-20 hidden lg:flex">
                <div class="text-xl font-bold ml-10">
                    Выберите файл
                </div>
                <CrossCloseWindowSvg v-on:click="closeWindow"/>
            </div>
            <div
                class="flex h-full lg:h-[calc(100%-80px)]"
            >
                <AccountsComponent
                    v-model:user="user"
                    class="border-r border-gray-200 hidden lg:flex"
                />
                <div class="w-full h-full lg:w-2/3">
                    <GoogleFilesComponent
                        v-if="user.google_account !== null"
                        :connection-type="connectionTypes.SOURCE"
                        @close-window="closeWindow"
                        @submit-files-saving="submitFilesSaving"
                        :multi-select="props.multiSelect"
                        v-model:tables="selectedTables"
                    />
                    <AccountAuthorizationComponent
                        v-else
                        v-model:user="user"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineModel, ref, onMounted, defineEmits, defineProps } from "vue";
import CrossCloseWindowSvg from "@/components/UI/svg/CrossCloseWindowSvg.vue";
import AccountsComponent from "@/pages/CreateConnection/AccountsComponent.vue";
import GoogleFilesComponent from "@/components/GoogleModal/GoogleFilesComponent.vue";
import AccountAuthorizationComponent from "@/components/GoogleModal/AccountAuthorizationComponent.vue";
import {Api} from "@/service/api";
import {connectionTypes} from "@/service/config";

const isVisible = defineModel('visibility')

const user = ref({})

const emits = defineEmits(['submit'])

const selectedTables = defineModel('tables')


const props = defineProps({
    multiSelect: {
        type: Boolean,
        required: true,
    }
})

onMounted(async () => {
    user.value = await Api.getUserMeInfo()
})

function closeWindow() {
    isVisible.value = false
}

async function submitFilesSaving(values) {
    closeWindow()
    emits("submit", values)
}

</script>

<style scoped>
.bg-gray-transparent {
    background-color: rgba(65,65,65,0.61);
}
</style>